// Decides whether the server has a newer build than the one running in this tab.
//
// `meta` is the parsed /meta.json written at build time ({ version, buildId });
// `current` is what this bundle was built with. A build id (a timestamp stamped by
// scripts/build.js) is compared when both sides have one, so a release is detected
// without anyone bumping package.json. Older meta files only carry `version`, so that
// is the fallback. A dev server has no build id and never reports an update.
export const isNewBuildAvailable = (meta, current) => {
  if (!meta || typeof meta !== 'object') {
    return false;
  }

  if (meta.buildId) {
    // A dev server has no build id of its own, so it never reports an update.
    return current && current.buildId ? String(meta.buildId) !== String(current.buildId) : false;
  }

  if (meta.version && current && current.version) {
    return String(meta.version) !== String(current.version);
  }

  return false;
};

export const CHECK_INTERVAL_MS = 5 * 60 * 1000;

// Seconds the "updating" banner counts down before the page reloads on its own.
export const AUTO_RELOAD_SECONDS = 60;

const RELOAD_KEY = 'autoReloadedForBuild';

// The id the server currently advertises: the build id, else the version.
export const targetBuildId = (meta) => (meta && (meta.buildId || meta.version)) || null;

// Reload automatically at most once per advertised build. If the reload brought back a
// stale page (a cache in front of the server), a second reload would loop forever, so the
// banner stays and the user refreshes by hand.
export const shouldAutoReload = (targetId, storage) => {
  if (!targetId) {
    return false;
  }
  try {
    return storage.getItem(RELOAD_KEY) !== String(targetId);
  } catch (e) {
    return false;
  }
};

export const markAutoReload = (targetId, storage) => {
  try {
    storage.setItem(RELOAD_KEY, String(targetId));
  } catch (e) {
    // storage unavailable: shouldAutoReload then refuses, so no loop is possible
  }
};

// A page file that fails to load after a deploy: its old hashed file no longer exists.
export const isChunkLoadError = (error) => {
  const text = error && (error.name || '') + ' ' + (error.message || '');
  return /ChunkLoadError|Loading chunk [\w-]+ failed|Loading CSS chunk/i.test(text || '');
};
